import { useMemo } from 'react'
import { IUser } from '../types/user'
import { useTypedSelector } from './useTypedSelector'

export function useUserMeta(user: IUser) {
    const { auth } = useTypedSelector((s) => s)
    const hasPremium = useMemo(
        () => !!user.PremiumAccess?.length || user.id === auth.id,
        [user, auth]
    )

    const iAmFollower = useMemo(() => !!user.Folls?.length, [user])

    return {
        hasPremium,
        iAmFollower,
    }
}
